import React from "react";

const Select = (props) => {
  return (
    <>
      <div className="p-3">
        <label
          htmlFor="countries"
          className="block mb-2 pl-3 text-sm font-medium text-darkSecondary dark:text-lightSecondary"
        >
          {props.placeHolder}
        </label>
        <select
          id="countries"
          ref={props.refrence}
          className={`px-2.5 pb-2.5 pt-4 text-sm text-lightTextPrimary appearance-none w-full
          dark:text-darkTextPrimary 
          dark:bg-darkPrimary bg-lightPrimary 
          shadow-md border dark:border-gray-600 dark:focus:border-blue-500 border-gray-300 focus:border-blue-600
          focus:outline-none focus:ring-0 peer 
          ${props.rounded === undefined ? "rounded-lg" : props.rounded}`}
        >
          {props.options.map((element) => (
            <option
              selected={element.code === "021" ? true : false}
              style={{ zoom: 1.15 }}
              value={element.id}
              key={element.id}
            >
              {element.name}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default Select;
